(function ($) {

	$(function () {
		$(document).ready(function ($) {
			$(".table-row").click(function () {
				window.document.location = $(this).data("href");
			});
		});
	});
})(jQuery);